// src/components/LessonSelect.js
import * as React from "react";
import {
    Box, Select, MenuItem, ListItemIcon, ListItemText, Typography,
} from "@mui/material";

// The markers used in the lesson menu
// The markers used in the lesson menu
const markerForScore = (score) => {
    if (score >= 1) return "✔"; // 🌝✔️💯
    if (score >= 0.7) return "🌖️";
    if (score >= 0.4) return "🌓";
    if (score >= 0.2) return "🌘";
    if (score > 0) return "🌑";
    return "\u200B";
};
const getLessonScore = (lessonFilename, lessonScores) => lessonScores?.[lessonFilename] ?? 0;

export default function LessonPopupMenu({
                                            allLessons,
                                            selectedLesson,
                                            onChange,
                                            lessonScores,
                                            learningMode

                                        }) {

    if (!allLessons) return;

    return (
        <Select
            className="lesson-select"
            fullWidth
            autoWidth
            value={selectedLesson ?? ""}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty

            // (Optionnel) on applique aussi le style au menu via MenuProps
            MenuProps={{
                PaperProps: {
                    className: "lesson-menu",
                    sx: {
                        "& .MuiMenuItem-root": {
                            alignItems: "flex-start",
                        }
                    },
                },
            }}
            renderValue={(value) => {
                if (value === "" || value == null) {
                    return <Typography color="text.secondary">Choisir une leçon…</Typography>;
                }
                const lecon = allLessons[value];
                const s = getLessonScore(lecon.file, lessonScores);
                const marker = markerForScore(s);
                const firstLesson = allLessons.find(l => l.file !== null).file
                const pct = Math.round(s * 100);

                return (
                    <Box sx={{display: "flex", alignItems: "flex-start", py: 0.5}}>
                        {learningMode === "single" ?
                            <Box sx={{minWidth: 28, mr: 1, textAlign: "center"}}>
                                {marker}
                            </Box>
                            :
                            ""

                        }
                        <Box sx={{display: "flex", flexDirection: "column"}}>
                            <Typography title={`${pct}% complété`}>
                                {(learningMode === "single" ? lecon.title : firstLesson + "-" + lecon.title)}
                            </Typography>
                            <Typography>
                                {lecon.course}
                            </Typography>
                        </Box>
                    </Box>
                );
            }}
        >
            {allLessons.map((lecon, index) => {
                const s = getLessonScore(lecon.file, lessonScores);
                const marker = markerForScore(s);
                const pct = Math.round(s * 100);

                return (
                    <MenuItem
                        key={index}
                        value={index}
                        sx={{
                            alignItems: "flex-start", // <- crucial pour laisser la 2e ligne s’afficher
                            py: 1,
                        }}
                    >
                        <ListItemIcon sx={{minWidth: 28, mt: 0.25, color: "text.primary"}}>
                            {marker}
                        </ListItemIcon>
                        <ListItemText
                            primary={lecon.title}
                            secondary={lecon.course}
                            sx={{whiteSpace: "normal"}} // au cas où, pour autoriser le wrap
                        />
                    </MenuItem>
                );
            })}
        </Select>
    );
}